import dayjs from 'shared/dayjs'
import { SupportedLocalesEnum } from 'types/SupportedLocalesEnum'

export const setDateLocale = async (locale: SupportedLocalesEnum) => {
  if (
    locale === SupportedLocalesEnum.enUs ||
    locale === SupportedLocalesEnum.pseudo
  ) {
    dayjs.locale('en')
  } else {
    switch (locale) {
      case SupportedLocalesEnum.deDe:
        await import('dayjs/locale/de')
        dayjs.locale('de')
        break
      case SupportedLocalesEnum.ptBr:
        await import(`dayjs/locale/pt-br`)
        dayjs.locale('pt-br')
        break
      case SupportedLocalesEnum.ptPt:
        await import(`dayjs/locale/pt`)
        dayjs.locale('pt')
        break
      case SupportedLocalesEnum.frFr:
        await import(`dayjs/locale/fr`)
        dayjs.locale('fr')
        break
      case SupportedLocalesEnum.itIt:
        await import(`dayjs/locale/it`)
        dayjs.locale('it')
        break
      case SupportedLocalesEnum.esEs:
        await import(`dayjs/locale/es`)
        dayjs.locale('es')
        break
      case SupportedLocalesEnum.enGb:
        await import(`dayjs/locale/en-gb`)
        dayjs.locale('en-gb')
        break
      case SupportedLocalesEnum.zhHans:
        await import(`dayjs/locale/zh-cn`)
        dayjs.locale('zh-cn')
        break
      case SupportedLocalesEnum.zhHant:
        await import(`dayjs/locale/zh-hk`)
        dayjs.locale('zh-hk')
        break
    }
  }
}
